/**
 * Convert HTML to plain text with newlines (mirrors server/helpers/html-to-plain-text.js).
 * @param {string} html
 * @returns {string}
 */
export function htmlToPlainText(html) {
  if (!html || typeof html !== 'string') {
    return '';
  }
  let s = html;
  s = s.replace(/\r\n/g, '\n');
  s = s.replace(/<br\s*\/?>/gi, '\n');
  s = s.replace(/<\/(p|div|li|h[1-6]|tr)>/gi, '\n');
  s = s.replace(/<[^>]*>/g, '');
  s = s
    .replace(/&nbsp;/gi, ' ')
    .replace(/&#160;/g, ' ')
    .replace(/\u00a0/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
  s = s.replace(/[ \t]+\n/g, '\n');
  s = s.replace(/\n{3,}/g, '\n\n');
  return s.trim();
}

/** @param {string} html */
export function plainTextFromDescription(html) {
  if (!html || typeof html !== 'string') {
    return '';
  }
  if (!/<[a-z][\s\S]*>/i.test(html)) {
    return html.trim();
  }
  return htmlToPlainText(html);
}
